import { Card } from "@engaging-tech/components"
import styled from "styled-components"

/* eslint-disable import/prefer-default-export */
export const CreateCard = styled(Card)`
  cursor: ${({ isOpen }) => (isOpen ? "inherit" : "pointer")};
`
